import { IGetEmpreendimentoByIdUseCase } from "../../../presentation/useCases/read/get_empreendimento_by_id_use_case";
import { Empreendimento } from "../../models/empreendimento";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";

/**
 * getEmpreendimentoByIdUseCase
 */

export class GetEmpreendimentoByIdUseCase implements IGetEmpreendimentoByIdUseCase {
  constructor(private readonly repository: IIncorporacaoRepository) { }

  async getEmpreendimentoById(idEmpreendimento: number): Promise<Empreendimento> {
    const response = await this.repository.getEmpreendimentoById(idEmpreendimento);
    return response

  }
}
